







































import InlineSVG from 'vue-inline-svg';
import Vue from 'vue';
import TIcons from '@/types/TIcons';

interface IOverlayComponent {
  closeIconPath: string;
}

export default Vue.extend({
  name: `Overlay`,
  components: { InlineSVG },
  data(): IOverlayComponent {
    return {
      closeIconPath: TIcons.close,
    };
  },
  props: {
    disableSelfClosable: {
      default: false,
      type: Boolean,
    },
    imageMode: {
      default: false,
      type: Boolean,
    },
    isVisible: {
      default: false,
      required: true,
      type: Boolean,
    },
    rounded: {
      default: false,
      type: Boolean,
    },
  },
  mounted(): void {
    window.addEventListener(`keyup`, this.onKeyUp);
  },
  beforeDestroy(): void {
    window.removeEventListener(`keyup`, this.onKeyUp);
  },
  methods: {
    closeOverlay(): void {
      if(!this.disableSelfClosable) {
        this.$emit(`close-overlay`);
      }
    },
    onKeyUp(event: KeyboardEvent) {
      if(event.keyCode === 27) {
        this.closeOverlay();
      }
    },
  },
});
